import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import HandbookChapter from './HandbookChapter.vue';
import CharactersBackgrounds from '@/pages/Characters/CharactersBackgrounds.vue';
let HandbookBackgrounds = class HandbookBackgrounds extends Vue {
};
HandbookBackgrounds = __decorate([
    Component({
        components: {
            HandbookChapter,
            CharactersBackgrounds
        }
    })
], HandbookBackgrounds);
export default HandbookBackgrounds;
